// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--u6U1R","list":"list--iKpEd","uploadButton":"uploadButton--g1JVM","item":"item--u05bj"};